import {
  ButtonBase,
  Icon,
  IconSizeClasses,
  Logo,
} from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';

import { AuthGuard } from '$shared/auth/auth-guard';
import { useAccessControlGuard } from '$shared/custom-hooks/useAccessControlGuard';

import { Avatar } from '$components/header/avatar';
import { SubscriptionHeader } from '$components/subscription-header/subscription-header';

interface HeaderProps {
  onToggleSidebar: () => void;
}

export function Header({ onToggleSidebar }: HeaderProps): ReactElement {
  const canViewDevices = useAccessControlGuard('VIEW_DEVICE_OVERVIEW');

  return (
    <header className="header">
      <AuthGuard>
        <div className="header__nav-logo">
          <ButtonBase className="header__menu" title="toggle" onClick={onToggleSidebar}>
            <Icon name="hamburger-menu" size={IconSizeClasses.Small} />
          </ButtonBase>
          <Logo className="header__logo" />
        </div>
        <SubscriptionHeader showDeviceUsage={canViewDevices} />
        <Avatar />
      </AuthGuard>
    </header>
  );
}
